// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getTagSetServ,
//   addTagServ,
//   updateTagServ,
//   deleteTagServ,
// } from "../../services/tag.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";
// function TagList() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetCategoryFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getTagSetServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "Total Tags",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Active Tags",
//       count: statics?.activeCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Inactive Tags",
//       count: statics?.inactiveCount,
//       bgColor: "#FFA426",
//     },
//   ];
//   useEffect(() => {
//     handleGetCategoryFunc();
//   }, [payload]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [addFormData, setAddFormData] = useState({
//     name: "",
//     slug: "",
//     description: "",
//     status: "",
//     show: false,
//   });
//   const handleAddCategoryFunc = async () => {
//     setIsLoading(true);
//     try {
//       let response = await addTagServ(addFormData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setAddFormData({
//           name: "",
//           slug: "",
//           description: "",
//           status: "",
//           show: false,
//         });
//         handleGetCategoryFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };
//   const handleDeleteCategoryFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this tag?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteTagServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetCategoryFunc();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };
//   const [editFormData, setEditFormData] = useState({
//     name: "",
//     slug: "",
//     description: "",
//     status: "",
//     _id: "",
//   });
//   const handleUpdateCategoryFunc = async () => {
//     setIsLoading(true);

//     try {
//       let response = await updateTagServ(editFormData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({
//           name: "",
//           slug: "",
//           description: "",
//           status: "",
//           _id: "",
//         });
//         handleGetCategoryFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };

//    const [totalPages, setTotalPages] = useState(1);
    
//       useEffect(() => {
//         if (statics?.totalCount && payload.pageCount) {
//           const pages = Math.ceil(statics.totalCount / payload.pageCount);
//           setTotalPages(pages);
//         }
//       }, [statics, payload.pageCount]);
    
//       const handlePageChange = (newPage) => {
//         if (newPage >= 1 && newPage <= totalPages) {
//           setPayload({ ...payload, pageNo: newPage });
//         }
//       };
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Product Management" selectedItem="Tags" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">Tags</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({ ...payload, searchKey: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn btn-primary w-100 borderRadius24"
//                   style={{ background: "#6777EF" }}
//                   onClick={() => setAddFormData({ ...addFormData, show: true })}
//                 >
//                   Add Tag
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>

//                       <th className="text-center py-3">Name</th>
//                       <th className="text-center py-3">Slug</th>
//                       <th className="text-center py-3">Description</th>
//                       <th className="text-center py-3">Status</th>
//                       <th className="text-center py-3">Created At</th>
//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                               <td className="text-center">
//                                   {(payload.pageNo - 1) * payload.pageCount + i + 1}
//                                 </td>

//                                 <td className="font-weight-600 text-center">
//                                   {v?.name}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.slug}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.description}
//                                 </td>
//                                 <td className="text-center">
//                                   {v?.status ? (
//                                     <div
//                                       className="badge py-2"
//                                       style={{ background: "#63ED7A" }}
//                                     >
//                                       Active
//                                     </div>
//                                   ) : (
//                                     <div
//                                       className="badge py-2 "
//                                       style={{ background: "#FFA426" }}
//                                     >
//                                       Inactive
//                                     </div>
//                                   )}
//                                 </td>
//                                 <td className="text-center">
//                                   {moment(v?.createdAt).format("DD-MM-YY")}
//                                 </td>
//                                 <td className="text-center">
//                                   <a
//                                     onClick={() => {
//                                       setEditFormData({
//                                         name: v?.name,
//                                         slug: v?.slug,
//                                         description: v?.description,
//                                         status: v?.status,
//                                         _id: v?._id,
//                                       });
//                                     }}
//                                     className="btn btn-info mx-2 text-light shadow-sm"
//                                   >
//                                     Edit
//                                   </a>
//                                   <a
//                                     onClick={() =>
//                                       handleDeleteCategoryFunc(v?._id)
//                                     }
//                                     className="btn btn-warning mx-2 text-light shadow-sm"
//                                   >
//                                     Delete
//                                   </a>
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>

//                 <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5 px-3 py-3 mt-4">
//                   <div className="d-flex align-items-center gap-2">
//                     <span className="fw-semibold text-secondary">Show</span>
//                     <select
//                       className="form-select form-select-sm custom-select"
//                       value={payload.pageCount}
//                       onChange={(e) =>
//                         setPayload({
//                           ...payload,
//                           pageCount: parseInt(e.target.value),
//                           pageNo: 1,
//                         })
//                       }
//                     >
//                       {[10, 25, 50, 100].map((v) => (
//                         <option key={v} value={v}>
//                           {v}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <nav>
//                     <ul className="pagination pagination-sm mb-0 custom-pagination">
//                       <li
//                         className={`page-item ${
//                           payload.pageNo === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo - 1)}
//                         >
//                           &lt;
//                         </button>
//                       </li>

//                       {[...Array(totalPages)].map((_, i) => {
//                         const page = i + 1;
//                         if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= payload.pageNo - 1 &&
//                             page <= payload.pageNo + 1)
//                         ) {
//                           return (
//                             <li
//                               key={page}
//                               className={`page-item ${
//                                 payload.pageNo === page ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => handlePageChange(page)}
//                               >
//                                 {page}
//                               </button>
//                             </li>
//                           );
//                         } else if (
//                           (page === payload.pageNo - 2 && page > 2) ||
//                           (page === payload.pageNo + 2 && page < totalPages - 1)
//                         ) {
//                           return (
//                             <li key={page} className="page-item disabled">
//                               <span className="page-link">...</span>
//                             </li>
//                           );
//                         }
//                         return null;
//                       })}

//                       <li
//                         className={`page-item ${
//                           payload.pageNo === totalPages ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo + 1)}
//                         >
//                           &gt;
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>

//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {addFormData?.show && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setAddFormData({
//                       name: "",
//                       slug: "",
//                       description: "",
//                       status: "",
//                       show: false,
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Add Tag</h5>

//                     <label className="mt-3">Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, name: e.target.value })
//                       }
//                     />

//                     <label className="mt-3">slug</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, slug: e.target.value })
//                       }
//                     />

//                     <label className="mt-3">Description</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, description: e.target.value })
//                       }
//                     />
//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           status: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>
//                     <button
//                       className="btn btn-success w-100 mt-4"
//                       onClick={
//                         addFormData?.name && addFormData?.slug && addFormData?.description && addFormData?.status && !isLoading
//                           ? handleAddCategoryFunc
//                           : undefined
//                       }
//                       disabled={
//                         !addFormData?.name || !addFormData?.slug || !addFormData?.description || !addFormData?.status || isLoading
//                       }
//                       style={{
//                         opacity:
//                           !addFormData?.name ||
//                           !addFormData?.slug ||
//                           !addFormData?.description ||
//                           !addFormData?.status ||
//                           isLoading
//                             ? "0.5"
//                             : "1",
//                       }}
//                     >
//                       {isLoading ? "Saving..." : "Submit"}
//                     </button>
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {addFormData?.show && <div className="modal-backdrop fade show"></div>}
//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setEditFormData({
//                       name: "",
//                       slug: "",
//                       description: "",
//                       status: "",
//                       _id: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update Tag</h5>

//                     <label className="mt-3">Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           name: e.target.value,
//                         })
//                       }
//                       value={editFormData?.name}
//                     />
                    
//                     <label className="mt-3">slug</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           slug: e.target.value,
//                         })
//                       }
//                       value={editFormData?.slug}
//                     />

//                     <label className="mt-3">Description</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           description: e.target.value,
//                         })
//                       }
//                       value={editFormData?.description}
//                     />
//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           status: e.target.value,
//                         })
//                       }
//                       value={editFormData?.status}
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>
//                     {editFormData?.name && editFormData?.slug && editFormData?.description && editFormData?.status ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleUpdateCategoryFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default TagList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getTagSetServ,
  addTagServ,
  updateTagServ,
  deleteTagServ,
} from "../../services/tag.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";

function TagList() {
  const [list, setList]       = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);

  const handleGetCategoryFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getTagSetServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  const staticsArr = [
    { title: "Total Tags",    count: statics?.totalCount,    icon: "ti-tag"          },
    { title: "Active Tags",   count: statics?.activeCount,   icon: "ti-circle-check" },
    { title: "Inactive Tags", count: statics?.inactiveCount, icon: "ti-circle-x"     },
  ];

  useEffect(() => { handleGetCategoryFunc(); }, [payload]);

  const [isLoading, setIsLoading] = useState(false);

  /* ── Add ── */
  const [addFormData, setAddFormData] = useState({
    name: "", slug: "", description: "", status: "", show: false,
  });

  const handleAddCategoryFunc = async () => {
    setIsLoading(true);
    try {
      let response = await addTagServ(addFormData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setAddFormData({ name: "", slug: "", description: "", status: "", show: false });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  /* ── Delete ── */
  const handleDeleteCategoryFunc = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this tag?");
    if (confirmed) {
      try {
        let response = await deleteTagServ(id);
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetCategoryFunc();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Internal Server Error");
      }
    }
  };

  /* ── Edit ── */
  const [editFormData, setEditFormData] = useState({
    name: "", slug: "", description: "", status: "", _id: "",
  });

  const handleUpdateCategoryFunc = async () => {
    setIsLoading(true);
    try {
      let response = await updateTagServ(editFormData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ name: "", slug: "", description: "", status: "", _id: "" });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  /* ── Pagination ── */
  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages)
      setPayload({ ...payload, pageNo: newPage });
  };

  const addValid  = addFormData.name && addFormData.slug && addFormData.description && addFormData.status;
  const editValid = editFormData.name && editFormData.slug && editFormData.description && editFormData.status;

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Product Management" selectedItem="Tags" />

      <div className="mainContainer">
        <TopNav pageTitle="Tags" pagePath="Home / Product Management / Tags" />

        <div className="pl-root">

          {/* ── Stat Cards ── */}
          <div className="pl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="pl-stat-val">{v.count ?? "—"}</div>
                  <div className="pl-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="pl-toolbar">
            <span className="pl-toolbar-title">Tags</span>

            <input
              className="pl-input"
              placeholder="Search tags..."
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
            />

            <select
              className="pl-select"
              onChange={(e) => setPayload({ ...payload, status: e.target.value })}
            >
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button
              className="pl-btn pl-btn-red"
              onClick={() => setAddFormData({ ...addFormData, show: true })}
            >
              <i className="ti ti-plus" aria-hidden="true" />
              Add Tag
            </button>
          </div>

          {/* ── Table ── */}
          <div className="pl-table-wrap">
            <div className="pl-table-scroll">
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Slug</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(8)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(7)].map((__, j) => (
                          <td key={j} className="pl-skel-cell">
                            <Skeleton height={18} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: "48px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v._id}>
                        <td>
                          <span className="pl-sr">
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </span>
                        </td>

                        <td style={{ fontWeight: 600, color: "#1c0a0a" }}>{v?.name}</td>

                        <td>
                          <span className="pl-cat-chip">{v?.slug}</span>
                        </td>

                        <td style={{ maxWidth: "240px", color: "#666" }}>
                          {v?.description || "—"}
                        </td>

                        <td>
                          <span className={`pl-badge ${v?.status ? "active" : "inactive"}`}>
                            <i
                              className={`ti ${v?.status ? "ti-circle-check" : "ti-circle-x"}`}
                              style={{ fontSize: "13px" }}
                              aria-hidden="true"
                            />
                            {v?.status ? "Active" : "Inactive"}
                          </span>
                        </td>

                        <td style={{ color: "#888", fontSize: "13px" }}>
                          {moment(v?.createdAt).format("DD MMM YYYY")}
                        </td>

                        <td>
                          <div style={{ display: "flex", gap: "8px" }}>
                            <button
                              className="pl-view-btn"
                              onClick={() =>
                                setEditFormData({
                                  name: v?.name,
                                  slug: v?.slug,
                                  description: v?.description,
                                  status: v?.status,
                                  _id: v?._id,
                                })
                              }
                            >
                              <i className="ti ti-pencil" aria-hidden="true" />
                              Edit
                            </button>
                            <button
                              className="pl-btn pl-btn-danger"
                              style={{ height: "34px", padding: "0 14px", fontSize: "14px" }}
                              onClick={() => handleDeleteCategoryFunc(v?._id)}
                            >
                              <i className="ti ti-trash" aria-hidden="true" />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="pl-pagination">
              <div className="pl-show-row">
                Show
                <select
                  className="pl-select"
                  style={{ height: "36px", padding: "0 10px" }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="pl-page-btns">
                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: "13px" }} />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 || page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`pl-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return (
                      <button key={page} className="pl-pg-btn" disabled>...</button>
                    );
                  }
                  return null;
                })}

                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: "13px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          ADD TAG MODAL
      ══════════════════════════════════════ */}
      {addFormData?.show && (
        <div className="pl-modal-overlay">
          <div className="pl-modal">
            <div className="pl-modal-header">
              <span className="pl-modal-title">Add Tag</span>
              <button
                className="pl-modal-close"
                onClick={() =>
                  setAddFormData({ name: "", slug: "", description: "", status: "", show: false })
                }
              >
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body">
              <label className="pl-field-label">Name</label>
              <input
                className="pl-field-input"
                type="text"
                placeholder="Tag name"
                value={addFormData.name}
                onChange={(e) => setAddFormData({ ...addFormData, name: e.target.value })}
              />

              <label className="pl-field-label">Slug</label>
              <input
                className="pl-field-input"
                type="text"
                placeholder="tag-slug"
                value={addFormData.slug}
                onChange={(e) => setAddFormData({ ...addFormData, slug: e.target.value })}
              />

              <label className="pl-field-label">Description</label>
              <input
                className="pl-field-input"
                type="text"
                placeholder="Short description"
                value={addFormData.description}
                onChange={(e) => setAddFormData({ ...addFormData, description: e.target.value })}
              />

              <label className="pl-field-label">Status</label>
              <select
                className="pl-field-input"
                style={{ cursor: "pointer" }}
                value={addFormData.status}
                onChange={(e) => setAddFormData({ ...addFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>

            <div className="pl-modal-footer">
              <button
                className="pl-btn"
                style={{ background: "#f0f0f0", color: "#555", height: "40px" }}
                onClick={() =>
                  setAddFormData({ name: "", slug: "", description: "", status: "", show: false })
                }
              >
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: "40px", opacity: addValid && !isLoading ? 1 : 0.5 }}
                disabled={!addValid || isLoading}
                onClick={addValid && !isLoading ? handleAddCategoryFunc : undefined}
              >
                {isLoading ? "Saving..." : "Save Tag"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          EDIT TAG MODAL
      ══════════════════════════════════════ */}
      {editFormData?._id && (
        <div className="pl-modal-overlay">
          <div className="pl-modal">
            <div className="pl-modal-header">
              <span className="pl-modal-title">Update Tag</span>
              <button
                className="pl-modal-close"
                onClick={() =>
                  setEditFormData({ name: "", slug: "", description: "", status: "", _id: "" })
                }
              >
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body">
              <label className="pl-field-label">Name</label>
              <input
                className="pl-field-input"
                type="text"
                value={editFormData.name}
                onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
              />

              <label className="pl-field-label">Slug</label>
              <input
                className="pl-field-input"
                type="text"
                value={editFormData.slug}
                onChange={(e) => setEditFormData({ ...editFormData, slug: e.target.value })}
              />

              <label className="pl-field-label">Description</label>
              <input
                className="pl-field-input"
                type="text"
                value={editFormData.description}
                onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
              />

              <label className="pl-field-label">Status</label>
              <select
                className="pl-field-input"
                style={{ cursor: "pointer" }}
                value={editFormData.status}
                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>

            <div className="pl-modal-footer">
              <button
                className="pl-btn"
                style={{ background: "#f0f0f0", color: "#555", height: "40px" }}
                onClick={() =>
                  setEditFormData({ name: "", slug: "", description: "", status: "", _id: "" })
                }
              >
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: "40px", opacity: editValid && !isLoading ? 1 : 0.5 }}
                disabled={!editValid || isLoading}
                onClick={editValid && !isLoading ? handleUpdateCategoryFunc : undefined}
              >
                {isLoading ? "Saving..." : "Update Tag"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TagList;